import { effect, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../../modules/shared/shared.global-service';
import { selectFolder } from '../../../../../modules/content/store/person/person.selectors';
import { FilterBuilder } from 'packages/client/src/app/modules/content/helper/filter.builder';
import { SszRegionObject } from '@libs/types/src/list/object-type/ssz-region.object';
import { InfiniteScrollStore } from 'packages/client/src/app/modules/shared/store/common/infinite-scroll.store';
import { szzRegionFrag } from './folder-sick-notes-detail-page.query';
import { FolderSickNotesObject } from '@libs/types/src/services/object-type/folder/folder-sick-notes.object';

@Injectable()
export class FolderSickNotesDetailPageStore extends ComponentStoreV2Factory {
    folder = globalStore!.selectSignal(selectFolder);
    sszSszRegions: SszRegionObject[] | null = null;
    lastSickNote: FolderSickNotesObject | null = null;

    public readonly sszRegionScroll = new InfiniteScrollStore<SszRegionObject>(
        this.api.getListSszRegions,
        {},
        false,
        szzRegionFrag,
    );

    constructor() {
        super();
        this.api.getListSszRegions(new FilterBuilder().limit(100).filter()).then((counties) => {
            this.sszSszRegions = counties?.items || null;
        });

        effect(async () => {
            const folder = this.folder() || this.data.getFolder();
            if (!folder) return;
            this.lastSickNote = await this.api.getSickNotes(
                new FilterBuilder()
                    .where('folderId', folder.id)
                    .sort('incapacityStartDate', 'DESC')
                    .limit(1)
                    .filter(),
            ).then((res) => res?.items?.[0] || null);
        });
    }
}
